import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { RuleDraw } from '@/components/generals/rule-draw'

import { EASE_CLASS, MICRO_FAINT } from '@/constants/type'
import { PRACTICE } from '@/constants/about'

export const PracticeLedger: FC = (): ReactNode => {
    return (
        <ul className='mt-10 sm:mt-14'>
            {PRACTICE.map((row, index) => (
                <li key={row.index}>
                    <Reveal delay={index * 0.05}>
                        <div className='group relative overflow-hidden py-6 sm:py-7'>
                            <RuleDraw className='absolute inset-x-0 top-0' delay={index * 0.05} />

                            <span
                                aria-hidden='true'
                                className={`absolute inset-0 origin-left scale-x-0 bg-fz-wash transition-transform duration-700 group-hover:scale-x-100 ${EASE_CLASS}`}
                            />

                            <div className='relative flex flex-col gap-3 sm:flex-row sm:items-baseline sm:gap-8'>
                                <span
                                    className={`w-8 shrink-0 transition-colors duration-500 group-hover:text-fz-ink ${MICRO_FAINT}`}
                                >
                                    {row.index}
                                </span>

                                <h3
                                    className={`shrink-0 font-serif leading-none tracking-[-0.01em] text-fz-ink transition-transform duration-700 group-hover:translate-x-2 sm:w-60 ${EASE_CLASS}`}
                                    style={{ fontSize: 'clamp(1.5rem, 2.4vw, 2rem)' }}
                                >
                                    {row.label}
                                </h3>

                                <p
                                    className={`flex-1 text-[15px] leading-relaxed text-fz-sub transition-transform duration-700 group-hover:translate-x-2 ${EASE_CLASS}`}
                                >
                                    {row.note}
                                </p>

                                <span
                                    className={`shrink-0 tabular-nums transition-colors duration-500 group-hover:text-fz-sub ${MICRO_FAINT}`}
                                >
                                    {row.count}
                                </span>
                            </div>
                        </div>
                    </Reveal>
                </li>
            ))}

            <li aria-hidden='true'>
                <RuleDraw />
            </li>
        </ul>
    )
}
